import React from 'react';
import './WordCloud.css';

/**
 * Облако ответов: размер плавно растёт с числом повторов, самые частые — в центре,
 * фраза не разрывается, число повторов — маленькой цифрой.
 * items: [{ text, count }]; size: 'screen' | 'compact' | 'projector' (большой экран).
 */
// Цвета слов — --cloud-1…5 в theme.css: читаемые и на светлом, и на тёмном фоне
const CLOUD_COLORS = 5;

function WordCloud({ items, size = 'screen', limit = 60 }) {
    const top = [...items].sort((a, b) => b.count - a.count).slice(0, limit);
    if (!top.length) return null;
    const maxCount = top[0].count;
    const [minPx, maxPx] = { compact: [16, 40], projector: [26, 96] }[size] || [20, 64];
    // Самые частые — в середину: раскладываем по очереди справа и слева от лидера
    const arranged = [];
    top.forEach((item, idx) => {
        const entry = { ...item, rank: idx };
        if (idx % 2) arranged.unshift(entry); else arranged.push(entry);
    });
    return (
        <div className={`word-cloud word-cloud--${size}`}>
            {arranged.map((item) => {
                const share = maxCount > 1 ? Math.sqrt((item.count - 1) / (maxCount - 1)) : 0.25;
                return (
                    <span
                        key={item.text}
                        className="word-cloud__item"
                        style={{
                            fontSize: `${Math.round(minPx + (maxPx - minPx) * share)}px`,
                            color: `var(--cloud-${(item.rank % CLOUD_COLORS) + 1})`,
                            fontWeight: share > 0.5 ? 800 : share > 0 ? 700 : 600,
                        }}
                        title={item.count > 1 ? `${item.text} — ${item.count}` : item.text}
                    >
                        {item.text}
                        {item.count > 1 && <sup>{item.count}</sup>}
                    </span>
                );
            })}
        </div>
    );
}

export default WordCloud;
